import axios from 'axios'
import store from '@/store'

// const baseUrl = 'https://web-gera.moerth.at:8449/api';
// const corsDomain = 'https://web-gera.moerth.at:8449/';

// const baseUrl = 'https://mum-gera.moerth.at:8449/api';
// const corsDomain = 'https://mum-gera.moerth.at:8449/';

const baseUrl = 'https://gera.at/redakteur';
const corsDomain = 'https://gera.at:8449/';

const AXIOS = axios.create({
  baseURL: baseUrl,
  timeout: 10000
});
export default {
    hello() {
    	const auth = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain} }
      return AXIOS.get(`/hello`, auth);
    },
    getUser(userId) {
    	const auth = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain} }
      return AXIOS.get(`/auth/user/` + userId, auth);
    },
    createUser(firstName, lastName) {
    	const auth = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain} }
      return AXIOS.post(`/auth/user/` + firstName + '/' + lastName);
    },
    executePostServerAction(action, data=null, auth=null, multipart=null) {
      // onsole.log('Action: ' + action)

      let authHeader = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain } } 
      if (!auth && multipart){
        // console.log('  MULTIPART')
        authHeader.headers = { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain, 'Authorization': 'Bearer ' + store.getters.getToken }
      }
      if (auth && !multipart){
        // console.log('  AUTH')
        authHeader.headers = { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain, 'Authorization': 'Bearer ' + store.getters.getToken }
      }
      if (auth && multipart){
        // console.log('  AUTH + MULTIPART')
        authHeader.headers = { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain, 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + store.getters.getToken }
      }
      return AXIOS.post(action, data, authHeader);
    }
}
